import { createSelector } from 'reselect';

const selectDomain = (state) => state.trainer;

export const selectSendingLook = createSelector([selectDomain], (state) => state.get('looking'));

export const selectDiscardingFromPlay = createSelector([selectDomain], (state) => state.get('discarding'));
